// Menerima file dari tombol "Bagikan" di HP (Web Share Target): Android
// mengirim file ke /web/share-target, service worker (public/sw.js)
// menampungnya lalu membuka Disbox, dan halaman meminta file-file itu dari
// service worker lewat postMessage. Modul ini diimpor paling awal (index.js)
// supaya pesan dari service worker tidak terlewat sebelum App siap.

let buffered = [];
const listeners = new Set();

function deliver(files) {
    if (!files || files.length === 0) return;
    if (listeners.size === 0) {
        buffered = buffered.concat(files);
        return;
    }
    for (const listener of listeners) listener(files);
}

if (typeof navigator !== 'undefined' && navigator.serviceWorker && typeof window !== 'undefined') {
    navigator.serviceWorker.addEventListener('message', (event) => {
        const data = event.data;
        if (data && data.type === 'disbox-shared-files' && Array.isArray(data.files)) deliver(data.files);
    });
    navigator.serviceWorker.startMessages();

    const url = new URL(window.location.href);
    if (url.searchParams.has('share-target')) {
        navigator.serviceWorker.ready.then((registration) => {
            const worker = navigator.serviceWorker.controller || registration.active;
            if (worker) worker.postMessage({ type: 'disbox-get-shared-files' });
        }).catch(() => {});
        url.searchParams.delete('share-target');
        window.history.replaceState(window.history.state, '', url.toString());
    }
}

export function takeSharedFiles() {
    const files = buffered;
    buffered = [];
    return files;
}

export function onSharedFiles(listener) {
    listeners.add(listener);
    if (buffered.length > 0) {
        const files = buffered;
        buffered = [];
        listener(files);
    }
    return () => listeners.delete(listener);
}
